<template>
  <section v-if="data" class="bg-white shadow overflow-hidden sm:rounded-md">
    <div class="bg-white shadow overflow-hidden sm:rounded-lg">
      <div class="px-4 py-5 sm:px-6">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Episoden ({{ podcast.num_episodes }} insgesamt)
        </h3>
      </div>
      <div class="border-t border-gray-200">
        <ul role="list" class="divide-y divide-gray-200">
          <li v-for="episode in data" :key="episode.id">
            <a :href="episode.web_uri" class="block hover:bg-gray-50" target="_blank">
              <div class="flex items-center px-4 py-4 sm:px-6">
                <div class="min-w-0 flex-1 flex items-center">
                  <div class="flex-shrink-0">
                    <img class="h-12 w-12 rounded-md" :src="podcast.image_uri" alt="episode.title" />
                  </div>
                  <div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-1 md:gap-4">
                    <div>
                      <p class="text-sm font-medium text-teal-600 truncate">
                        {{ episode.title }}
                      </p>
                      <p class="mt-2 flex items-center text-sm text-gray-500">
                        <CalendarIcon class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" aria-hidden="true" />
                        <span class="truncate">
                          {{ $d(new Date(episode.published_at), 'long') }} Uhr
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <ArrowTopRightOnSquareIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <div v-if="meta">
        <Paginator
          :from="meta.from"
          :to="meta.to"
          :current="meta.current_page"
          :total="meta.total"
          @previous="prev"
          @next="next"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
import { onMounted, ref, computed, watchEffect } from 'vue';
import client from '@/client';
import _ from "lodash";

const props = defineProps({podcast: Object});
const data = ref(null);
const meta = ref(null);

const empty = computed(() => _.isEmpty(data.value));

const fetch = (page=0) =>
{
  const parent = props.podcast.id;
  const target = '/api/podcasts/' + parent + '/episodes';
  const params = {params: {page: page}};

  client.get(target, params)

  .then(result =>
  {
    data.value = result.data.data;
    meta.value = result.data.meta;
  })

  .catch(error =>
  {
    data.value = null;
    meta.value = null;
  });
};

const prev = () => fetch(_.max([1, meta.value.current_page-1]));
const next = () => fetch(_.min([meta.value.last_page, meta.value.current_page+1]));

const mounted = onMounted(() => fetch(props.podcast.id));
const watcher = watchEffect(() => fetch(props.podcast.id));
</script>
